import { Link } from 'react-router-dom';
import { ArrowUpRight, Home } from 'lucide-react';
import { FadeUp } from '@/components/site/Reveal';
import SEO from '@/components/site/SEO';

export default function NotFound() {
  return (
    <>
      <SEO title="404 — Slinkflow" noindex />
      <section className="relative flex min-h-screen items-center overflow-hidden pt-32">
        <div className="absolute -top-32 left-0 h-[520px] w-[520px] hero-gradient-orb" />
        <div className="absolute right-0 bottom-0 h-[420px] w-[420px] hero-orb-2" />
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 relative">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.3em] text-cyan">Error 404</p>
            <h1 className="mt-6 max-w-4xl font-display text-[88px] font-light leading-[0.95] tracking-[-0.04em] md:text-[180px] lg:text-[240px] gradient-text">404</h1>
            <p className="mt-6 max-w-xl text-[20px] text-ink-500">The page you&apos;re looking for has wandered off. Let&apos;s get you back home.</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/" className="btn-cyan inline-flex items-center gap-2 rounded-full px-7 py-4 text-[15px] font-medium"><Home className="h-4 w-4" /> Go home</Link>
              <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-ink-200 bg-white px-7 py-4 text-[15px] font-medium text-ink-900">Contact us <ArrowUpRight className="h-4 w-4" /></Link>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
